import React, { useState } from 'react';
import { FaPlus, FaMinus  } from 'react-icons/fa';

const InvoiceApp = () => {
  const [items, setItems] = useState([{ description: '', unitPrice: '', quantity: 1, amount: 0 }]);
  const [tax, setTax] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [clientName, setClientName] = useState('');
  const API_URL = process.env.REACT_APP_API_URL;

  const addItem = () => {
    setItems([...items, { description: '', unitPrice: '', quantity: 1, amount: 0 }]);
  };

  const removeItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = items.map((item, i) => {
      if (i === index) {
        const updatedItem = { ...item, [field]: value };
        updatedItem.amount = updatedItem.unitPrice * updatedItem.quantity;
        return updatedItem;
      }
      return item;
    });
    setItems(updatedItems);
  };

  const calculateTotal = () => {
    const subtotal = items.reduce((sum, item) => sum + item.amount, 0);
    const taxAmount = (subtotal * tax) / 100;
    const discountAmount = (subtotal * discount) / 100;
    return (subtotal + taxAmount - discountAmount).toFixed(2);
  };

  return (
    <div className="p-4 max-w-lg mx-auto bg-white shadow-md rounded-md">
      <h1 className="text-2xl font-bold text-center mb-4">Invoice Generator</h1>
      <div className="mb-4">
        <label className="block font-medium">Client Name</label>
        <input 
          type="text" 
          value={clientName} 
          onChange={(e) => setClientName(e.target.value)}
          className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200" />
      </div>

      {items.map((item, index) => (
        <div key={index} className="grid grid-cols-4 gap-2 items-center mb-2">
          <input 
            type="text" 
            placeholder="Description" 
            value={item.description} 
            onChange={(e) => handleItemChange(index, 'description', e.target.value)}
            className="col-span-2 p-2 border rounded-md" />
          <input 
            type="number" 
            placeholder="Unit Price" 
            value={item.unitPrice} 
            onChange={(e) => handleItemChange(index, 'unitPrice', e.target.value)}
            className="p-2 border rounded-md text-right" />
          <input 
            type="number" 
            placeholder="Qty" 
            value={item.quantity} 
            onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
            className="p-2 border rounded-md text-right" />
          {/* <span className="text-right">{item.amount}</span> */}
          <button onClick={() => removeItem(index)} className="text-red-500">
            <FaMinus  />
          </button>
          <button 
            onClick={addItem} 
                className="flex items-center gap-1 text-blue-500 mb-4">
            <FaPlus />
            </button>
        </div>
      ))}

      

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block font-medium">Tax (%)</label>
          <input 
            type="number" 
            value={tax} 
            onChange={(e) => setTax(e.target.value)}
            className="w-full p-2 border rounded-md text-right" />
        </div>
        <div>
          <label className="block font-medium">Discount (%)</label>
          <input 
            type="number" 
            value={discount} 
            onChange={(e) => setDiscount(e.target.value)}
            className="w-full p-2 border rounded-md text-right" />
            
        </div>
      </div>

      <div className="flex justify-between items-center font-bold">
        <span>Total:</span>
        <span>Rs.{calculateTotal()}</span>
      </div>

      <button className="w-full bg-blue-500 text-white p-3 rounded-md mt-4">Submit</button>
    </div>
  );
};

export default InvoiceApp;
